(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-submit-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);

  if (params.get('contact_posted') === 'true') {
    const popup = document.getElementById('success-popup');

    if (popup) {
      popup.classList.add('show');

      setTimeout(function() {
        popup.classList.remove('show');
      }, 3000);
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
